import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { MyHrContractCard } from "my-hr/components";
import { useMyHrContract, useMyHrEmployee } from "my-hr/hooks";
import {
  MyTimeAdmissionCardByAdmin,
  MyTimeEmployeeRequestsCard,
  MyTimePageHeader,
} from "my-time/components";
import { useMyTimeActualDate } from "my-time/hooks";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import { useOcIsMobile, useOcProperty } from "oc/hooks";

export const MyTimeEmployeeRequestsPage = () => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  let { contract, employee } = useParams<{
    contract: string;
    employee: string;
  }>();

  const { date, formattedDate, year, month, handleDateChange } =
    useMyTimeActualDate();

  const { data: contractData } = useMyHrContract({
    contract: contract,
  });

  const { data: employeeData } = useMyHrEmployee({
    employeeId: employee,
  });

  const { data: changeMyTimeEnabledData } = useOcProperty({
    resource: "myTime",
    key: "changeMyTimeEnabled",
  });

  const { data: changeWorkingTimeEnabledData } = useOcProperty({
    resource: "myTime",
    key: "changeWorkingTimeEnabled",
  });

  const { data: approveAllRequestsEnabledData } = useOcProperty({
    resource: "myTime",
    key: "approveAllRequestsEnabled",
  });

  const changeMyTimeEnabled = changeMyTimeEnabledData === "true" ? true : false;
  const approveAllRequestsEnabled =
    approveAllRequestsEnabledData === "true" ? true : false;
  const changeWorkingTimeEnabled =
    changeWorkingTimeEnabledData === "true" ? true : false;
  const showApproveAllButton = changeMyTimeEnabled && approveAllRequestsEnabled;

  return (
    <OcPageTransition>
      <OcPageNameTitle title={t("OC_EMPLOYEE_REQUESTS")} goBack={true} />
      <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
        <MyTimePageHeader
          formattedDate={formattedDate}
          date={date}
          onDateChange={handleDateChange}
          isMobile={isMobile}
        />
        <Box height="16px" />
        <MyHrContractCard employee={employeeData} contract={contractData} />
        <Box height="16px" />
        <MyTimeEmployeeRequestsCard
          label={t("MY_TIME_REQUESTS")}
          contractCode={contract}
          employeeCode={employee}
          date={date}
          examinerView={true}
          showApproveAllButton={showApproveAllButton}
        />
        <Box height="16px" />
        <MyTimeAdmissionCardByAdmin
          contractCode={contract}
          employeeCode={employee}
          year={year}
          month={month}
          changeMyTimeEnabled={changeMyTimeEnabled}
          changeWorkingTimeEnabled={changeWorkingTimeEnabled}
          isMobile={isMobile}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyTimeEmployeeRequestsPage;
